import { Link, useNavigate } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Logo";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const { user } = useAuth();
  const nav = useNavigate();

  const links = [
    { to: "/#features", label: "Features" },
    { to: "/#how", label: "How it works" },
    { to: "/#benefits", label: "Benefits" },
    { to: "/#faq", label: "FAQ" },
    { to: "/#contact", label: "Contact" },
  ];

  return (
    <header className="sticky top-0 z-50 glass-nav">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <Logo size="md" />
        </Link>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a key={l.label} href={l.to} className="text-sm text-slate-600 hover:text-brand transition-colors duration-200" data-testid={`nav-${l.label.toLowerCase().replace(/\s/g,'-')}`}>
              {l.label}
            </a>
          ))}
        </nav>
        <div className="hidden md:flex items-center gap-3">
          {user ? (
            <Button data-testid="nav-dashboard" onClick={() => nav(`/${user.role}`)} className="btn-orange hover:bg-[#FF6A00]">
              Go to Dashboard
            </Button>
          ) : (
            <>
              <Link to="/login" className="text-sm font-medium text-slate-700 hover:text-brand" data-testid="nav-login">Log in</Link>
              <Button data-testid="nav-signup" onClick={() => nav("/signup")} className="btn-orange hover:bg-[#FF6A00]">Get started</Button>
            </>
          )}
        </div>
        <button className="md:hidden" onClick={() => setOpen(!open)} data-testid="nav-mobile-toggle">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t bg-white/95">
          <div className="px-6 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <a key={l.label} href={l.to} onClick={() => setOpen(false)} className="text-slate-700">{l.label}</a>
            ))}
            {user ? (
              <Button className="btn-orange hover:bg-[#FF6A00]" onClick={() => nav(`/${user.role}`)}>Dashboard</Button>
            ) : (
              <div className="flex gap-3">
                <Link to="/login" className="flex-1"><Button variant="outline" className="w-full">Log in</Button></Link>
                <Link to="/signup" className="flex-1"><Button className="btn-orange hover:bg-[#FF6A00] w-full">Sign up</Button></Link>
              </div>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
